"use strict";

exports.__esModule = true;
exports.ScreenReaderOnly = exports.Body = exports.PageTitle = exports.HiddenText = exports.HeroTitle = void 0;

var _Typography = require("./Typography");

exports.HeroTitle = _Typography.HeroTitle;
exports.HiddenText = _Typography.HiddenText;
exports.PageTitle = _Typography.PageTitle;
exports.Body = _Typography.Body;
exports.ScreenReaderOnly = _Typography.ScreenReaderOnly;